module.exports = __webpack_public_path__ + "static/media/comment.d5fa76d1.svg";